import { Auth, API } from "aws-amplify";
import spfxioapi from "./spfxioapi";
import { w3cwebsocket as WebsocketClient } from "websocket";
import CONFIG from "../config.js";

/** @class */
export default class spfxdata {

  /**
   * Constructs a new spfxdata object
   * @param {object} config spfxdata config options 
   */
  constructor(config) {
    var localConfig = (config)?config:{
             defaultTTL: (20*60) * 1000 //default 20 minutes set in millisconds
            ,itemMaxSize: 3000 // 3000 bytes
             };
             
    

    
    this.delay = ms => new Promise(res => setTimeout(res, ms));   
  }

 
  setuser(susr){
	  //this.susr=susr;
	  this.spfxioapi = new spfxioapi(susr);
  }
  
  getuser(){
	  
	  //this.susr=susr;
	return (this.spfxioapi)?this.spfxioapi.susr:undefined;
  }
  /**
   * This is used to verify a valid spf record
   * @param {string} dnsname - Domain name to be checked
   */
  async dodata(dnsname) {

    var result = {
                isvalidformat: (this.isvalidformat(dnsname) &&
                true)
           , isvalidrecord: true
           , isvalidspf: true
        }

        result.valid = (result.isvalidformat
                            &&result.isvalidrecord
                            &&result.isvalidspf);

    return(result)

  }

   getdomaindatamodel(){
       return ({ domain: ''
                    , hosteddomainid: ''
                    , status: ''
                    , dmarc: ''
                    , spf: ''
                    , lastUpdated: new Date().toLocaleDateString()
                    , actions: ''
                    , stats: []
                    , senders: -1
                    , key: -1
                    , defaultspfauthpolicy:''
                    , defaultsourceauditing:''
                    , enableIpIndexing:''
                });
   }
  
   async getdomainsforuser(){
      
       try{
    	   var domaindata = await this.spfxioapi.getuserdomains();
    	   return (domaindata);
	   }catch(err){
		   alert(err);
		   return "";
	   }
	   
   }
   async getuserorglist(){
	      
       try{
    	   var orglist = await this.spfxioapi.getuserorglist();
    	   return (orglist);
	   }catch(err){
		   var obj = { error : err };
		   return obj;
	   }
   }
   async updateuserprimaryorg(params){
	   try{
    	   var retval = await this.spfxioapi.updateuserprimaryorg(params);
    	   return retval;
	   }catch(err){
		   var obj = { error : err };
		   return obj;
	   }
   }
   
   async getuserprivileges(){
	   
	   //return ({ role: "READONLY" });
	   return ({ role: "WRITE" });
   }
   
   async addhosteddomainpolicy(params){
	   var retobj = {};
	   
	   try{
	      var domaindata = await this.spfxioapi.addhosteddomainpolicy(params);
    	  return (domaindata);
	   }catch(err){
			  retobj.err = JSON.stringify(err);
	   }
	   
	   return retobj;
   }
   async addhosteddomaindmarcpolicy(params){
	   
	   return new Promise(async(resolve,reject)=>{
		 
		   try{
			   params.spfx.dmarcpct=params.spfx.dmarcpct/100.0;
		      var domaindata = await this.spfxioapi.adddmarcpolicy(params);
	    	  resolve (domaindata);
		   }catch(err){
			  
			  reject(err);
		   }
		   
	   });
	   
   }
   async addhosteddomain(params){
	  var retobj = {};
	  try{
		  params.spfx.dmarcpct=params.spfx/100.0;
		  var domaindata = await this.spfxioapi.addhosteddomain(params);
	 	  retobj.data = domaindata;
	  }catch(err){
		  //alert(JSON.stringify(err));
		  retobj.err = "error adding domain";
	  }
	  return retobj;
	   
   }
   
   async addauthorizedsender(params){
	   var retobj = {};
	   try{
    	   var domaindata = await this.spfxioapi.addauthorizedsender(params);
    	   retobj.data = domaindata;
	   }catch(err){
		   retobj.err = "error processing your request";
	   }
	   return retobj;
   }
   
   
   async adddomainkey(params){
	     var retobj = {};
		   
	     return new Promise((resolve,reject)=>{
	    	 	try{
		    	   var domaindata = this.spfxioapi.adddomainkey(params);
		    	  resolve(domaindata);
			   }catch(err){
				   reject(err);
			   } 
	     })
		   
		   
   }
   
   async upsertdomainkeys(params){
	   
	   
	   
	   var retobj = {};
		   
	     return new Promise((resolve,reject)=>{
	    	 	try{
		    	   var keydata = this.spfxioapi.upsertdkimkeys(params);
		    	  resolve(keydata);
			   }catch(err){
				   reject(err);
			   } 
	     })
   }
   
   
   async deleteauthorizedsender(params){
	   var retobj = {};
	   try{
    	   var domaindata = await this.spfxioapi.deleteauthorizedsender(params);
    	   retobj.data = domaindata;
	   }catch(err){
		   retobj.err = err;
	   }
	   return retobj;
   }
   async getauthorizedsenders(hosteddomainid){
      
       //await this.delay(2500);
       var ddata =  [{    hosteddomainid: 'xxxxxx1'
                    , domain: 'domain1.com'
                    , sendingdomain: 'google.com'
                    , includes: ['_spf.google.com','_spf1.google.com']
                    , defaultaction: 'softfail'
                    , lookups: 3
                    , key:1
                    },
                    {    hosteddomainid: 'xxxxxx1'
                    , domain: 'domain1.com'
                    , sendingdomain: 'notgoogle.com'
                    , includes: ['_spf.notgoogle.com','_spf1.notgoogle.com']
                    , defaultaction: 'softfail'
                    , lookups: 2
                    , key:2
                    }
                    ,
                    {    hosteddomainid: 'xxxxxx1'
                    , domain: 'domain1.com'
                    , sendingdomain: 'spfxio.com'
                    , includes: ['_spf.notgoogle.com','_spf1.notgoogle.com']
                    , defaultaction: 'softfail'
                    , lookups: 2
                    , key:2
                    }
                ];
       //var ddata1 = JSON.parse('[{\"domain\":\"dcssm.com\",\"spfxio_id\":\"oxfdx6b\",\"emailaddress\":\"tony.dimichele@dcssm.com\",\"hosteddomainid\":1,\"domain_defaultSpfPolicy\":\"-\",\"domain_defaultSourceAuditing\":1,\"senders\":[{\"hosteddomainid\":1,\"authsenderid\":1,\"senderdomain\":\"amazonses.com\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"amazonses.com\"]},{\"hosteddomainid\":1,\"authsenderid\":2,\"senderdomain\":\"dmarcdepot.com\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"_spf.dmarcdepot.com\"]},{\"hosteddomainid\":1,\"authsenderid\":3,\"senderdomain\":\"outlook.com\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"spf.protection.outlook.com\"]},{\"hosteddomainid\":1,\"authsenderid\":4,\"senderdomain\":\"mailgun.info\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"mailgun.org\"]}]},{\"domain\":\"investorsbank.com\",\"spfxio_id\":\"622470e\",\"emailaddress\":\"tony.dimichele@dcssm.com\",\"hosteddomainid\":2,\"domain_defaultSpfPolicy\":\"-\",\"domain_defaultSourceAuditing\":1,\"senders\":[{\"hosteddomainid\":2,\"authsenderid\":5,\"senderdomain\":\"bankserv.com\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"bankserv.com\"]},{\"hosteddomainid\":2,\"authsenderid\":6,\"senderdomain\":\"cashedge.com\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"customercenter.net\"]},{\"hosteddomainid\":2,\"authsenderid\":7,\"senderdomain\":\"mandrillapp.com\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"spf.mandrillapp.com\"]},{\"hosteddomainid\":2,\"authsenderid\":9,\"senderdomain\":\"outlook.com\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"spf.protection.outlook.com\"]},{\"hosteddomainid\":2,\"authsenderid\":10,\"senderdomain\":\"pphosted.com\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"spf-00286d01.pphosted.com\"]},{\"hosteddomainid\":2,\"authsenderid\":11,\"senderdomain\":\"salesforce.com\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"_spf.salesforce.com\"]},{\"hosteddomainid\":2,\"authsenderid\":12,\"senderdomain\":\"mailgun.info\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"mailgun.org\"]},{\"hosteddomainid\":2,\"authsenderid\":13,\"senderdomain\":\"btbpo.net\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"_spf.btbpo.net\"]},{\"hosteddomainid\":2,\"authsenderid\":14,\"senderdomain\":\"customercenter.net\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"customercenter\"]},{\"hosteddomainid\":2,\"authsenderid\":15,\"senderdomain\":\"emailnotify.net\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"emailnotify.net\"]},{\"hosteddomainid\":2,\"authsenderid\":16,\"senderdomain\":\"mailgun.net\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"mailgun.org\"]},{\"hosteddomainid\":2,\"authsenderid\":17,\"senderdomain\":\"mbox.net\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"mbox.net\"]},{\"hosteddomainid\":2,\"authsenderid\":18,\"senderdomain\":\"sendgrid.net\",\"defaultSpfPolicy\":\"-\",\"defaultSourceAuditing\":1,\"includes\":[\"sendgrid.net\"]}]},{\"domain\":\"gaffline.com\",\"spfxio_id\":null,\"emailaddress\":\"tony.dimichele@dcssm.com\",\"hosteddomainid\":null,\"domain_defaultSpfPolicy\":null,\"domain_defaultSourceAuditing\":null,\"senders\":[]},{\"domain\":\"myinvestorsbank.com\",\"spfxio_id\":null,\"emailaddress\":\"tony.dimichele@dcssm.com\",\"hosteddomainid\":null,\"domain_defaultSpfPolicy\":null,\"domain_defaultSourceAuditing\":null,\"senders\":[]},{\"domain\":\"irongatecr.com\",\"spfxio_id\":null,\"emailaddress\":\"tony.dimichele@dcssm.com\",\"hosteddomainid\":null,\"domain_defaultSpfPolicy\":null,\"domain_defaultSourceAuditing\":null,\"senders\":[]},{\"domain\":\"barawakmachining.com\",\"spfxio_id\":\"4vbj1ps\",\"emailaddress\":\"tony.dimichele@dcssm.com\",\"hosteddomainid\":null,\"domain_defaultSpfPolicy\":null,\"domain_defaultSourceAuditing\":null,\"senders\":[]},{\"domain\":\"saavha.com\",\"spfxio_id\":\"w2h9yng\",\"emailaddress\":\"tony.dimichele@dcssm.com\",\"hosteddomainid\":null,\"domain_defaultSpfPolicy\":null,\"domain_defaultSourceAuditing\":null,\"senders\":[]},{\"domain\":\"saavah.com\",\"spfxio_id\":\"8bj965a\",\"emailaddress\":\"tony.dimichele@dcssm.com\",\"hosteddomainid\":null,\"domain_defaultSpfPolicy\":null,\"domain_defaultSourceAuditing\":null,\"senders\":[]}]'); 
       
       var ddata1 = await this.spfxioapi.getuserdomainsenders();
       
       var sdrs=null
       for(let rec of ddata1){
    	   if(rec.spfxio_id==hosteddomainid){
    		   
    		   sdrs = rec.senders;
    	   }
       }
        
       return (sdrs);
       
   }

   async getaudittrails(spfxio_id){
	   
	   try
	   {
		   var ddata = await this.spfxioapi.getaudittrails(spfxio_id);
		   return ddata;
		   
	   }catch(err){
		   alert(err)
		   return '';
	   }
	   
   }
   

async getdomainkeynameservers(spfxio_id){
	 return new Promise(async (resolve,reject)=>{
		  
			   this.spfxioapi.gethosteddomaindnsns(spfxio_id,"_domainkey").then((ns)=>{
				   resolve(ns);
			   }).catch((err)=>{
				   reject(err);
			   });
			   
	  });
}
  
async getdnsrecordsfordomain(spfxio_id){
	   
	   return new Promise(async (resolve,reject)=>{
		  
		   try
		   {
			   var ddata1 = await this.spfxioapi.gethosteddomaindns(spfxio_id);
			   //alert(JSON.stringify(ddata1));
			   
			   var retval = [];
			   var rxhd = new RegExp(spfxio_id+'\.spfx\.((io)|(info))\.?$');
			   
		       for(let d of ddata1){
		    	   if(rxhd.exec(d.Name)){
		    		   retval.push(d);;
		    	   }
		       }
		       
			   resolve(retval);
		   }catch(err){
			   reject(err);
		   }
	   });
	   
   }
   
   
   async connectws(){
	  
	   
	  
	   return new Promise( (resolve,reject)=>{
		   
	   try{
		   //region,userpoolid,usersub
		   const wsendpoint = CONFIG.wsendpoint//'wss://wahjzx27c3.execute-api.us-east-1.amazonaws.com/dev';
		   const event='';
		   const uri = `${wsendpoint}?connectionType=${event}&Authorizer=${this.spfxioapi.susr.idToken.jwtToken}&usersub=${this.spfxioapi.susr.idToken.payload.sub}`;
		   const client = new WebsocketClient(uri);
		   resolve(client)
		   
	   }catch(err){
		   reject(err);  
	   }
		 /*
	    client.on('connectFailed', (error) => {
		    client.abort();
		    reject(uri);
		});
		client.on('connect', (connection) => {
		   resolve(connection);
		});
		
	  */
	   
	   });
   }
   
   
  /* async apihosteddnsrecords(spfxio_id){
	   var jwtToken = this.susr.idToken.jwtToken
	   
	   return API.put('gethosteddomaindns', '/gethosteddomaindns', { body:{ "jwtToken" : jwtToken, "spfxio_id" : spfxio_id},headers:{}});
   }*/
   
   
   /*
   async getdomaindata(hosteddomainid){

        var ddata = 
                {    
                      hosteddomainid: 'xxxxxx1'
                    , domain: 'domain1.com'
                    , defaultpolicy: 'fail'
                    , sourceauditing: 'enabled'
                }
        //await this.delay(2500);
       
        return ddata;
   }
	*/




}